import React, { useState } from "react";
import { useGetSubCategoriesQuery } from "../../../redux/service/modules/admin";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import CommonNavigator from "../../../components/common/CommonNavigator";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import SubCategoryDialog from "./SubCategoryDialog";
const SubCategoryDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);
    return (
        <Layout>
            <CustomAdminLayout
                title={"Sub Category Details"}
                createButtonText={"Add New Sub Category"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Sub Categories"}
            >
                <PaginatedDataTable
                    queryHook={useGetSubCategoriesQuery}
                    title="Sub Category Management"
                    paginationEnabled={true}
                    showEditColumn={true}
                    showCheckboxColumn={false}
                    appliedFilters={{ search: searchText }}
                    dialogType={"subcategory"}
                />
                <SubCategoryDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New Sub Category"}
                    ctaText={"ADD SUB CATEGORY"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default SubCategoryDetails;
